export function* generator_editor(): Generator<number, number, number> {
  while (true) {
    yield 0
  }
  return 0
}
